import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "flex flex-col w-2/3 gap-8 text-black-lp-300" }
const _hoisted_3 = { class: "flex flex-col gap-6 pl-5 pr-32" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "ml-5 text-20px font-semibold" }, "Parameter Perhitungan Komisi", -1)
const _hoisted_6 = { class: "ml-5 grid grid-cols-7 gap-x-16 gap-y-6 pr-32" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px w-full font-semibold text-center" }, " Tier ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px w-full col-span-2 font-semibold" }, " Publish Rate ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px w-full col-span-2 font-semibold" }, " Shipping Surcharge ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px w-full col-span-2 font-semibold" }, " Nilai Barang COD ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", { class: "col-span-7 border-gray-lp-400" }, null, -1)
const _hoisted_12 = { class: "flex justify-center content-center items-center text-12px xxl:text-14px w-full h-full" }
const _hoisted_13 = { class: "h-4" }
const _hoisted_14 = { class: "w-full col-span-2" }
const _hoisted_15 = { class: "w-full col-span-2" }
const _hoisted_16 = { class: "w-full col-span-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("hr", { class: "col-span-7 border-gray-lp-400" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_detail_layout = _resolveComponent("detail-layout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_detail_layout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetailData,
      title: "Ubah DTPOL",
      fullPage: true,
      "vertical-separator": false
    }, {
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_lp_button, {
            "text-color": "white",
            customClass: "w-full py-2.5",
            title: "Simpan",
            onClick: _ctx.onSaveForm,
            disabled: !_ctx.isFormValid
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_data_wrapper, { label: "Produk" }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.detailData.product,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.product = $event)),
                  disabled: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              label: "Deskripsi",
              optional: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.detailData.description,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.description = $event)),
                  type: "textarea",
                  textAreaRows: "6",
                  showMaxLength: true,
                  maxLength: "500",
                  placeholder: "Lorem ipsum"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _hoisted_4,
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.commissions, (fields, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: fields }, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.detailData.commissions[index].tier), 1)
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_lp_input, {
                    format: _ctx.formatDecimal,
                    modelValue: _ctx.detailData.commissions[index].publishRateCommission,
                    "onUpdate:modelValue": ($event: any) => (_ctx.detailData.commissions[index].publishRateCommission = $event),
                    suffix: "%",
                    error: _ctx.commissionCalculationError[index].publishRateCommission,
                    errorIcon: false,
                    errorCaption: "Maks. 100"
                  }, null, 8, ["format", "modelValue", "onUpdate:modelValue", "error"])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode(_component_lp_input, {
                    format: _ctx.formatDecimal,
                    modelValue: 
                  _ctx.detailData.commissions[index].shippingSurchargeCommission
                ,
                    "onUpdate:modelValue": ($event: any) => (
                  _ctx.detailData.commissions[index].shippingSurchargeCommission
                 = $event),
                    suffix: "%",
                    error: 
                  _ctx.commissionCalculationError[index].shippingSurchargeCommission
                ,
                    errorIcon: false,
                    errorCaption: "Maks. 100"
                  }, null, 8, ["format", "modelValue", "onUpdate:modelValue", "error"])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_lp_input, {
                    format: _ctx.formatDecimal,
                    modelValue: _ctx.detailData.commissions[index].codCommission,
                    "onUpdate:modelValue": ($event: any) => (_ctx.detailData.commissions[index].codCommission = $event),
                    suffix: "%",
                    error: _ctx.commissionCalculationError[index].codCommission,
                    errorIcon: false,
                    errorCaption: "Maks. 100"
                  }, null, 8, ["format", "modelValue", "onUpdate:modelValue", "error"])
                ]),
                _hoisted_17
              ], 64))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain"]),
    (_ctx.saveConfirmation)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.saveEdit,
          onClose: _ctx.closeSaveConfirmation,
          title: "Konfirmasi Perubahan",
          message: 
      `Anda yakin ingin menyimpan perubahan detail DTPOL pada produk “${_ctx.detailData.product}” ?`
    ,
          image: "are-you-sure",
          textSuccess: "Simpan",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "message"]))
      : _createCommentVNode("", true),
    (_ctx.successSave)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onSubmit: _ctx.closeSuccessSave,
          title: "Perubahan Berhasil !",
          message: 
      `Detail DTPOL pada produk “${_ctx.detailData.product}” berhasil diubah.`
    ,
          image: "image-modal-success",
          textSuccess: "OK",
          class: "px-8"
        }, null, 8, ["onSubmit", "message"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      "on-submit": _ctx.onLeavePage,
      "on-close": _ctx.onCloseLeavePage,
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["on-submit", "on-close"]), [
      [_vShow, _ctx.leavePageConfirmation]
    ])
  ], 64))
}